import "./core/vendor";
import "babel-polyfill";
import cssVars from "css-vars-ponyfill";
import { toTop } from "./ui/to-top";
import { attachProductEvents } from "./templates/product";
import { attachCartPopupEvents } from './ui/cart-popup';
import { attachCollectionHeaderEvents } from './snippets/collection-header';
import { attachCollectionHeaderToggleLink } from './snippets/collection-header';
import { attachCollectionListeners } from './sections/home-feature-collection';
import { attachProductListeners } from './sections/home-featured-products';

// Document
cssVars({
  rootElement: document // default
});

attachProductEvents();
attachCollectionHeaderEvents();
attachCollectionHeaderToggleLink();
attachCartPopupEvents();
toTop();
attachCollectionListeners();
attachProductListeners();
